<div class="proposal-container">
    <div class="add-button">
        <ham-button outline="true" [size]="'xs'" icon="assets/hamIcons/plus-outline.svg" (buttonClick)="addRow()">
            {{ 'aumico_annual_report_proposal_add_new_item' | i18next }}
        </ham-button>
    </div>

    <div class="proposal" *ngIf="form">
        <form [formGroup]="form">
            <ng-container formArrayName="dataSource">
                <table class="custom-table">
                    <!-- Table Header -->
                    <thead>
                        <tr>
                            <th class="aumText aumOverflowEdit">
                                <ham-inline-table-cell-edit
                                    [value]="proposalDescription"
                                    (save)="onProposalDescriptionChange($event)"
                                ></ham-inline-table-cell-edit>
                            </th>
                            <th class="aumHighlight">
                                <span>{{ currentYearDate | dateLocale }}</span>
                            </th>
                            <th>
                                <span>{{ previousYearDate | dateLocale }}</span>
                            </th>
                            <th></th>
                        </tr>
                    </thead>

                    <!-- Table Body -->
                    <tbody>
                        <tr
                            *ngFor="let element of dataSource.controls; let rowIndex = index"
                            [formGroup]="element"
                            [formGroupName]="rowIndex"
                        >
                            <!-- Name Column -->
                            <td class="aumText aumTextCell">
                                <ng-container
                                    *ngIf="rowIndex !== dataSource.length - 1 && rowIndex !== dataSource.length - 2"
                                >
                                    <input
                                        [formControl]="form.get('dataSource')['controls'][rowIndex]['controls']['name']"
                                        placeholder="{{ 'aumico_annual_report_proposal_enter_text' | i18next }}"
                                        hamInput
                                    />
                                </ng-container>
                                <ng-container *ngIf="rowIndex === dataSource.length - 2">
                                    <ham-inline-table-cell-edit
                                        [value]="proposalCarriedForwardText"
                                        (save)="onSaveProposalCarriedForward($event)"
                                    ></ham-inline-table-cell-edit>
                                </ng-container>
                                <ng-container *ngIf="rowIndex === dataSource.length - 1">
                                    <ham-inline-table-cell-edit
                                        [value]="proposalAvailableRetainedEarningText"
                                        (save)="onSaveProposalAvailableRetainedEarnings($event)"
                                    ></ham-inline-table-cell-edit>
                                </ng-container>
                            </td>

                            <td
                                class="aumHighlight aumTextCell"
                                [ngClass]="{
                                    todoHighlight:
                                        !form.get('dataSource')['controls'][rowIndex]['controls']['currentValue']
                                            .value &&
                                        rowIndex !== dataSource.length - 2 &&
                                        rowIndex !== dataSource.length - 1
                                }"
                            >
                                <ng-container
                                    *ngIf="rowIndex !== dataSource.length - 2 && rowIndex !== dataSource.length - 1"
                                >
                                    <input
                                        class="number-input"
                                        [formControl]="
                                            form.get('dataSource')['controls'][rowIndex]['controls']['currentValue']
                                        "
                                        placeholder="{{ 'aumico_annual_report_proposal_enter_text' | i18next }}"
                                        hamInput
                                        type="number"
                                    />
                                </ng-container>
                                <ng-container *ngIf="rowIndex === dataSource.length - 2">
                                    <aum-form-field-label>
                                        {{
                                            currentCarriedForwardValue != null
                                                ? (currentCarriedForwardValue | finNumber : numberFormat)
                                                : ''
                                        }}
                                    </aum-form-field-label>
                                </ng-container>
                                <ng-container *ngIf="rowIndex === dataSource.length - 1">
                                    <aum-form-field-label>
                                        {{
                                            currentAvailableRetainedEarnings != null
                                                ? (currentAvailableRetainedEarnings | finNumber : numberFormat)
                                                : ''
                                        }}
                                    </aum-form-field-label>
                                </ng-container>
                            </td>

                            <!-- Previous Value Column -->
                            <td
                                class="aumTextCell"
                                [ngClass]="{
                                    todoHighlight:
                                        !form.get('dataSource')['controls'][rowIndex]['controls']['previousValue']
                                            .value &&
                                        rowIndex !== dataSource.length - 2 &&
                                        rowIndex !== dataSource.length - 1
                                }"
                            >
                                <ng-container
                                    *ngIf="rowIndex !== dataSource.length - 2 && rowIndex !== dataSource.length - 1"
                                >
                                    <input
                                        hamInput
                                        type="number"
                                        class="number-input"
                                        [formControl]="
                                            form.get('dataSource')['controls'][rowIndex]['controls']['previousValue']
                                        "
                                        placeholder="{{ 'aumico_annual_report_proposal_enter_text' | i18next }}"
                                    />
                                </ng-container>
                                <ng-container *ngIf="rowIndex === dataSource.length - 2">
                                    <aum-form-field-label>
                                        {{
                                            previousCarriedForwardValue != null
                                                ? (previousCarriedForwardValue | finNumber : numberFormat)
                                                : ''
                                        }}
                                    </aum-form-field-label>
                                </ng-container>
                                <ng-container *ngIf="rowIndex === dataSource.length - 1">
                                    <aum-form-field-label>
                                        {{
                                            previousAvailableRetainedEarnings != null
                                                ? (previousAvailableRetainedEarnings | finNumber : numberFormat)
                                                : ''
                                        }}
                                    </aum-form-field-label>
                                </ng-container>
                            </td>

                            <!-- Remove Column -->
                            <td>
                                <ng-container
                                    *ngIf="rowIndex !== dataSource.length - 2 && rowIndex !== dataSource.length - 1"
                                >
                                    <span (click)="removeAt(rowIndex)" class="ham-icon">
                                        <i class="grey-remove-icon"></i>
                                    </span>
                                </ng-container>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </ng-container>
        </form>

        <!-- AOP Description footnote -->
        <div class="footnote-row">
            <span
                hamCheckbox
                [formControl]="aopDescriptionCheckboxControl"
                (change)="onAopDescriptionCheckboxChange($event.checked)"
            >
                {{ 'aumico_annual_report_ccr_add_comment' | i18next }}
            </span>

            <div *ngIf="showAopDescription" class="footnote-editor">
                <ham-tiptap-toolbar [editor]="tiptapEditor" (imageSelected)="onTiptapImageSelected($event)">
                    <div #aopDescriptionHost class="tiptap-editor"></div>
                </ham-tiptap-toolbar>
            </div>
        </div>
    </div>
</div>

<!-- Confirm remove AOP description modal -->
<ham-confirm-decline-modal
    *ngIf="showRemoveAopDescriptionConfirm"
    (cancel)="cancelRemoveAopDescription()"
    (action)="confirmRemoveAopDescription()"
    footerAlignment="center"
    actionBtnText="{{ 'aumico_reports_confirm_delete' | i18next }}"
    noActionBtnText="{{ 'aumico_annual_report_cancel_button' | i18next }}"
>
    <div class="flex-center">
        <span class="ham-icon exclamation-wrapper">
            <i class="exclamation-outline-icon"></i>
        </span>
        <span class="workflow-text1">
            {{ 'aumico_reports_confirm_delete' | i18next }}
        </span>
    </div>
</ham-confirm-decline-modal>
